import React from "react";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function BenefitDescription({ heading, description, bulletpoints, fade }) {

  const dataAOS = `fade-${fade}`

  return (
    <div className="relative w-full md:w-1/2 p-4 md:p-0 md:pt-12" data-aos={dataAOS}>
      <h3 className="text-2xl md:text-3xl text-center md:text-justify font-bold tracking-wide leading-tight pb-6">
        {heading}
      </h3>
      <p className="text-lg md:text-xl lg:text-2xl text-gray-700 max-w-lg">
        {description}
      </p>
      <ul className="mt-4 text-base md:text-xl text-gray-700 max-w-lg">
        {bulletpoints && bulletpoints.map((point, index) => (
          <li key={index} className="py-2">
            <FontAwesomeIcon className="mr-4 text-green-500" icon={faCheckCircle} />
              {point}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BenefitDescription;